var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable:cyclomatic-complexity */
import { observable, observe, action, computed } from "mobx";
import { UIMessageModel, StakeButtonsStatusesModel } from "../../../models";
import { UIMessageStatus, BetStatus, ButtonModifiers, MessageModifiers, StakeButtonsModifiers } from "../../../enums";
import { createTransformer } from "mobx-utils";
var YourbetMiniBetSlipData = /** @class */ (function () {
    function YourbetMiniBetSlipData(provider, dict) {
        var _this = this;
        this.messages = createTransformer(function (purchaseId) {
            var allMessages = [];
            var tax = _this.getTax(purchaseId);
            if (_this.shouldDisplayError()) {
                allMessages = allMessages.concat(_this.formatedErrors());
            }
            _this.betStatus === BetStatus.NewOffer && allMessages.push(_this.formatedStakeChangeMessage(purchaseId));
            _this.betStatus === BetStatus.Accepted && allMessages.push(_this.formatedAcceptedMessage(purchaseId));
            var currentPurchase = _this.purchases.find(function (x) { return x.id === purchaseId; });
            if (currentPurchase && currentPurchase.shouldAcceptNewOdds) {
                allMessages.push(_this.formatedOddsChangeMessage(purchaseId));
            }
            tax !== "" && allMessages.push(_this.formatedTaxMessage(tax));
            if (_this.isBetWaitingOrAccepted) {
                allMessages = allMessages.concat(_this.getPurchaseMessages(purchaseId));
            }
            return allMessages;
        });
        this.provider = provider;
        this.errors = this.provider.errors;
        this.selections = this.provider.selections;
        this.purchases = this.provider.purchases;
        this.bets = this.provider.bets;
        this.dict = dict;
        this.disposeErrors = function () { };
        this.disposePurchases = function () { };
        this.disposeSelections = function () { };
        this.disposeBetStatus = function () { };
        this.disposeStakeButtonsStatus = function () { };
        this.disposePlaceBetButtonState = function () { };
        this.disposeBets = function () { };
        this.isPlaceBetButtonDisabled = true;
        this.betStatus = this.provider.betStatus;
        this.stakeButtonsStatus = new StakeButtonsStatusesModel({ minusEnabled: false, plusEnabled: true });
    }
    YourbetMiniBetSlipData.prototype.activate = function () {
        var _this = this;
        this.disposeErrors = observe(this.provider, "errors", function (x) {
            _this.updateErrors(x.newValue);
        });
        this.disposePurchases = observe(this.provider, "purchases", function (x) {
            _this.updatePurchases(x.newValue);
        });
        this.disposeSelections = observe(this.provider, "selections", function (x) {
            _this.updateSelections(x.newValue);
        });
        this.disposeBetStatus = observe(this.provider, "betStatus", function (x) {
            _this.updateBetStatus(x.newValue);
        });
        this.disposeStakeButtonsStatus = observe(this.provider, "stakeButtonsStatus", function (x) {
            _this.updateStakeButtonsStatus(x.newValue);
        });
        this.disposePlaceBetButtonState = observe(this.provider, "isPlaceBetButtonEnabled", function (x) {
            _this.setIsBetButtonDisabled(!x.newValue);
        });
        this.disposeBets = observe(this.provider, "bets", function (x) {
            _this.updateBets(x.newValue);
        });
        this.provider.activate();
    };
    YourbetMiniBetSlipData.prototype.deactivate = function () {
        this.provider.deactivate();
        this.betStatus = BetStatus.Default;
        this.disposeBetStatus();
        this.disposeErrors();
        this.disposePurchases();
        this.disposeSelections();
        this.disposeStakeButtonsStatus();
        this.disposePlaceBetButtonState();
        this.disposeBets();
    };
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "isWaiting", {
        //Testing purposes - delete after finish
        get: function () {
            return this.betStatus === BetStatus.Waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "isAccepted", {
        //Testing purposes - delete after finish
        get: function () {
            return this.betStatus === BetStatus.Accepted;
        },
        enumerable: true,
        configurable: true
    });
    YourbetMiniBetSlipData.prototype.changeStake = function (stake, buttonAction) {
        return this.provider.changeStake(stake, buttonAction);
    };
    YourbetMiniBetSlipData.prototype.updateSelections = function (updatedSelections) {
        this.selections = updatedSelections;
    };
    YourbetMiniBetSlipData.prototype.setIsBetButtonDisabled = function (value) {
        this.isPlaceBetButtonDisabled = value;
        return this.isPlaceBetButtonDisabled;
    };
    YourbetMiniBetSlipData.prototype.updateErrors = function (updatedErrors) {
        this.errors = updatedErrors;
    };
    YourbetMiniBetSlipData.prototype.updatePurchases = function (updatedPurchases) {
        this.purchases = updatedPurchases;
    };
    YourbetMiniBetSlipData.prototype.updateBets = function (updatedBets) {
        this.bets = updatedBets;
    };
    YourbetMiniBetSlipData.prototype.updateStakeButtonsStatus = function (updatedStatus) {
        this.stakeButtonsStatus = updatedStatus;
    };
    YourbetMiniBetSlipData.prototype.updateNewOfferStatus = function (waitingBetId, isAccepted) {
        this.provider.updateNewOfferStatus(waitingBetId, isAccepted);
    };
    YourbetMiniBetSlipData.prototype.updateOddsChangeStatus = function (isAccepted) {
        this.provider.updateOddsChangeStatus(isAccepted);
    };
    YourbetMiniBetSlipData.prototype.getBtnRejected = function () {
        return {
            label: this.dict.Clear,
            handler: this.clearPurchases,
            modifier: ButtonModifiers.clear
        };
    };
    YourbetMiniBetSlipData.prototype.getBtnAccepted = function () {
        return {
            label: this.dict.Clear,
            handler: this.clearPurchases,
            modifier: ButtonModifiers.clear
        };
    };
    YourbetMiniBetSlipData.prototype.getBtnNewOffer = function () {
        var stake = this.purchases.length && this.purchases[0] && this.purchases[0].stake;
        var betId = this.bets.length && this.bets[0] && this.bets[0].id || "0";
        return {
            label: stake,
            handler: this.updateNewOfferStatus.bind(this, betId, false),
            modifier: ButtonModifiers.changedStake
        };
    };
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "leftComponentStake", {
        get: function () {
            var stake = this.purchases.length && this.purchases[0] && this.purchases[0].stake || "0";
            var res = {
                handler: this.changeStake.bind(this),
                buttons: {
                    left: {
                        modifier: StakeButtonsModifiers.Minus,
                        handler: this.changeStake.bind(this, stake, StakeButtonsModifiers.Minus),
                        disabled: !this.stakeButtonsStatus.minusEnabled
                    },
                    right: {
                        modifier: StakeButtonsModifiers.Plus,
                        handler: this.changeStake.bind(this, stake, StakeButtonsModifiers.Plus),
                        disabled: !this.stakeButtonsStatus.plusEnabled
                    }
                }
            };
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "leftComponentButton", {
        get: function () {
            var betStatusKey = BetStatus[this.betStatus];
            var res;
            (typeof this["getBtn" + betStatusKey] === "function") ?
                res = this["getBtn" + betStatusKey]() :
                res = "";
            return res;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "rightComponent", {
        get: function () {
            var purchase = this.purchases.length && this.purchases[0];
            var bet = this.bets.length && this.bets[0];
            if (this.betStatus === BetStatus.Accepted) {
                return {
                    label: this.dict.RetainSelections,
                    handler: this.retainPurchases,
                    modifier: ButtonModifiers.place,
                    disabled: false
                };
            }
            else if (this.betStatus === BetStatus.NewOffer && bet) {
                return {
                    label: this.dict.AcceptStake,
                    handler: this.updateNewOfferStatus.bind(this, bet.id, true),
                    modifier: ButtonModifiers.accepted,
                    disabled: false
                };
            }
            else if (purchase && purchase.shouldAcceptNewOdds) {
                return {
                    label: this.dict.AcceptOdds,
                    handler: this.updateOddsChangeStatus.bind(this, true),
                    modifier: ButtonModifiers.accepted,
                    disabled: false
                };
            }
            else {
                var placeButtonLabel = this.isPlaceBetButtonDisabled && this.selections.findIndex(function (s) { return s.suspended === true; }) !== -1
                    ? this.dict.Danger
                    : this.dict.PlaceBets;
                return {
                    label: placeButtonLabel,
                    handler: this.placeBet.bind(this),
                    modifier: this.isPlaceBetButtonDisabled ? ButtonModifiers.disabled : ButtonModifiers.place,
                    disabled: this.isPlaceBetButtonDisabled
                };
            }
        },
        enumerable: true,
        configurable: true
    });
    YourbetMiniBetSlipData.prototype.updateBetStatus = function (updatedBetStatus) {
        this.betStatus = updatedBetStatus;
    };
    YourbetMiniBetSlipData.prototype.updateBetStatusToRejected = function () {
        this.updateBetStatus(BetStatus.Rejected);
    };
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "selectionsCount", {
        get: function () {
            return this.selections.length;
        },
        enumerable: true,
        configurable: true
    });
    YourbetMiniBetSlipData.prototype.removeError = function (key, type) {
        if (this.errors[key] && this.errors[key][type]) {
            this.errors.remove(this.errors[key]);
        }
        return this.errors;
    };
    YourbetMiniBetSlipData.prototype.formatedErrors = function () {
        var _this = this;
        var allErrors = [];
        this.errors.forEach(function (error, index) { return (Object.keys(error).forEach(function (x) {
            var formatedError = new UIMessageModel({
                id: "error-" + x,
                label: error[x].join(" "),
                modifier: MessageModifiers.Change,
                type: UIMessageStatus.Error,
                handler: _this.removeError.bind(_this, index, x)
            });
            allErrors.push(formatedError);
        }, _this)); }, this);
        return allErrors;
    };
    YourbetMiniBetSlipData.prototype.formatedAcceptedMessage = function (purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? "accepted-" + purchaseId : "accepted",
            modifier: MessageModifiers.Accepted,
            label: this.dict.BetsAccepted,
            type: UIMessageStatus.Accepted
        });
    };
    YourbetMiniBetSlipData.prototype.formatedOddsChangeMessage = function (purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? "oddsChanged-" + purchaseId : "oddsChanged",
            modifier: MessageModifiers.Change,
            label: this.dict.OddsChanged,
            type: UIMessageStatus.Default
        });
    };
    YourbetMiniBetSlipData.prototype.formatedStakeChangeMessage = function (purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? "stakeChanged-" + purchaseId : "stakeChanged",
            modifier: MessageModifiers.Change,
            label: this.dict.StakeChanged,
            type: UIMessageStatus.Waiting
        });
    };
    YourbetMiniBetSlipData.prototype.formatedTaxMessage = function (taxText, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? "tax-" + purchaseId : "tax",
            modifier: MessageModifiers.Tax,
            label: taxText,
            type: UIMessageStatus.Tax
        });
    };
    YourbetMiniBetSlipData.prototype.formatedPurchaseMessage = function (text, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? "purchase-msg-" + purchaseId : "purchase-msg",
            modifier: MessageModifiers.Purchase,
            label: text,
            type: UIMessageStatus.Purchase
        });
    };
    YourbetMiniBetSlipData.prototype.shouldDisplayError = function () {
        return (this.betStatus === BetStatus.Rejected || this.betStatus === BetStatus.Default) && this.errors.length !== 0 && this.selections.length > 0;
    };
    YourbetMiniBetSlipData.prototype.getTax = function (purchaseId) {
        var currentPurchase = this.purchases.find(function (x) { return x.id === purchaseId; });
        return currentPurchase && currentPurchase.tax || "";
    };
    YourbetMiniBetSlipData.prototype.getPurchaseMessages = function (purchaseId) {
        var _this = this;
        var currentMessages = [];
        var currentPurchase = this.purchases.find(function (x) { return x.id === purchaseId; });
        currentPurchase && currentPurchase.messages && currentPurchase.messages.forEach(function (msg) {
            msg !== "" && currentMessages.push(_this.formatedPurchaseMessage(msg, purchaseId));
        }, this);
        return currentMessages;
    };
    YourbetMiniBetSlipData.prototype.placeBet = function () {
        var _this = this;
        var result = false;
        this.purchases.forEach(function (p) {
            if (p && p.stake) {
                result = _this.provider.placeBet(p.stake, _this.selections);
            }
        }, this);
        return result;
    };
    YourbetMiniBetSlipData.prototype.removeSelection = function (selectionId) {
        var result = false;
        var selection = this.selections.find(function (sel) { return sel.id === selectionId; });
        if (selection) {
            result = this.provider.removeSelections([selection]);
        }
        return result;
    };
    YourbetMiniBetSlipData.prototype.retainPurchases = function () {
        var _this = this;
        var result = false;
        this.purchases.forEach(function (p) {
            if (p.id && p.viewKey) {
                result = _this.provider.retainPurchase(p.id, p.viewKey);
            }
        }, this);
        return result;
    };
    YourbetMiniBetSlipData.prototype.clearPurchases = function () {
        var result = false;
        var purchases = this.purchases.filter(function (x) { return x.id !== "" && x.viewKey !== undefined; });
        if (purchases.length > 0) {
            result = this.provider.clearAllPurchases(purchases);
        }
        return result;
    };
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "isBetWaitingOrAccepted", {
        get: function () {
            return this.betStatus === BetStatus.Waiting || this.betStatus === BetStatus.Accepted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YourbetMiniBetSlipData.prototype, "stakeValue", {
        get: function () {
            return this.purchases.length && this.purchases[0].stake || "0";
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], YourbetMiniBetSlipData.prototype, "errors", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], YourbetMiniBetSlipData.prototype, "purchases", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], YourbetMiniBetSlipData.prototype, "bets", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], YourbetMiniBetSlipData.prototype, "selections", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], YourbetMiniBetSlipData.prototype, "betStatus", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], YourbetMiniBetSlipData.prototype, "stakeButtonsStatus", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], YourbetMiniBetSlipData.prototype, "isPlaceBetButtonDisabled", void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "deactivate", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "isWaiting", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "isAccepted", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "changeStake", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "updateSelections", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "setIsBetButtonDisabled", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "updateErrors", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "updatePurchases", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "updateBets", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "updateStakeButtonsStatus", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "leftComponentStake", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "leftComponentButton", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "rightComponent", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "updateBetStatus", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "updateBetStatusToRejected", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "selectionsCount", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, String]),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "removeError", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "retainPurchases", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], YourbetMiniBetSlipData.prototype, "clearPurchases", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "isBetWaitingOrAccepted", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], YourbetMiniBetSlipData.prototype, "stakeValue", null);
    return YourbetMiniBetSlipData;
}());
export { YourbetMiniBetSlipData };
/* tslint:enable:cyclomatic-complexity */ 
//# sourceMappingURL=YourbetMiniBetSlipData.js.map